import { render, staticRenderFns } from "./NotificationPage2.vue?vue&type=template&id=46615830&scoped=true&"
import script from "./NotificationPage2.vue?vue&type=script&lang=ts&"
export * from "./NotificationPage2.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationPage2.vue?vue&type=style&index=0&id=46615830&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46615830",
  null
  
)

export default component.exports